module.exports = __webpack_public_path__ + "static/media/AI Hub.0bd3ba30.png";